export default {
  name: 'CoreVirtualDeviceMonitoringCardSkeleton'
};